module.exports = __webpack_public_path__ + "img/tw-btn_txt.287a66e6.png";